var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 132.29167 58.029209",
      },
    },
    [
      _c("g", { attrs: { transform: "translate(-22.579725,-154.43183)" } }, [
        _c("path", {
          staticStyle: {
            opacity: "1",
            "fill-opacity": "1",
            stroke: "none",
            "stroke-width": "1.68198478",
            "stroke-linecap": "butt",
            "stroke-linejoin": "miter",
            "stroke-miterlimit": "4",
            "stroke-dasharray": "none",
            "stroke-dashoffset": "0",
            "stroke-opacity": "1",
            "paint-order": "markers stroke fill",
          },
          style: { fill: _vm.isWhite ? "#fff" : "#120a08" },
          attrs: {
            d: "M 88.725318,154.44183 A 29.004635,29.004635 0 0 0 64.279823,167.84372 H 22.579725 l 4.151328,4.15132 h 35.382568 a 29.004635,29.004635 0 0 0 -1.5924,4.83646 h -28.95372 l 4.100688,4.10068 h 24.181768 a 29.004635,29.004635 0 0 0 -0.128999,2.5145 29.004635,29.004635 0 0 0 0.116098,2.32243 H 40.505114 l 4.100688,4.10069 h 15.861909 a 29.004635,29.004635 0 0 0 1.529813,4.83644 H 49.44225 l 4.151328,4.15133 H 64.19478 a 29.004635,29.004635 0 0 0 24.530538,13.59347 29.004635,29.004635 0 0 0 24.531022,-13.59347 h 10.60121 l 4.15132,-4.15133 h -12.55528 a 29.004635,29.004635 0 0 0 1.52982,-4.83644 h 15.86191 l 4.10068,-4.10069 h -19.33193 a 29.004635,29.004635 0 0 0 0.11609,-2.32243 29.004635,29.004635 0 0 0 -0.12852,-2.5145 h 24.18129 l 4.10068,-4.10068 H 116.9299 a 29.004635,29.004635 0 0 0 -1.5924,-4.83646 h 35.38257 l 4.15132,-4.15132 H 113.1713 A 29.004635,29.004635 0 0 0 88.725318,154.44183 Z m 0,3.93157 A 25.073283,25.073283 0 0 1 113.79861,183.44668 25.073283,25.073283 0 0 1 88.725318,208.51996 25.073283,25.073283 0 0 1 63.652035,183.44668 25.073283,25.073283 0 0 1 88.725318,158.3734 Z m -19.945873,18.57467 v 12.99673 h 2.710381 v -10.23045 l 2.858965,10.23045 h 2.809277 l 2.868523,-10.23045 v 10.23045 h 2.710858 v -12.99673 h -4.376837 l -2.592372,8.86547 -2.621993,-8.86547 z m 16.786869,0 v 12.99673 h 2.917732 v -12.99673 z m 5.716978,0 v 12.99673 h 2.710857 v -8.47513 l 5.825912,8.47513 h 2.927759 v -12.99673 h -2.71085 v 8.67914 l -5.914301,-8.67914 z m 14.470648,0 v 12.99673 h 2.91773 v -12.99673 z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }